export const CONTENT = "admin/content";
